import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LiveProvider } from "@/context/LiveContext";
import Login from "@/pages/Login";
import RegisterCompany from "@/pages/RegisterCompany";
import AppLayout from "@/components/AppLayout";
import DashboardPage from "@/pages/DashboardPage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import ApprovalsPage from "@/pages/ApprovalsPage";
import UsersPage from "@/pages/UsersPage";

const MANAGER_ROLES = ["owner", "manager"];

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-loader">
      <div className="w-3 h-3 rounded-full bg-primary led-pulse" />
    </div>
  );
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function Shell() {
  return (
    <LiveProvider>
      <AppLayout />
    </LiveProvider>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<RegisterCompany />} />
            <Route
              element={
                <Protected>
                  <Shell />
                </Protected>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/jobs/:id" element={<JobDetailPage />} />
              <Route
                path="/approvals"
                element={
                  <Protected roles={MANAGER_ROLES}>
                    <ApprovalsPage />
                  </Protected>
                }
              />
              <Route
                path="/users"
                element={
                  <Protected roles={MANAGER_ROLES}>
                    <UsersPage />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
